import type { JSX } from 'react'

import { NavGroup } from "/app/libraries/arcana/src/blocks/NavGroup/index.ts"
import { NavTab } from "/app/libraries/arcana/src/atoms/NavTab/index.ts"

import { useUnit } from 'effector-react'
import { navigate } from '~/core/router'
import { navbarRedirect } from '~/features/analytix/model/player/routes'
import { $modules } from '../model'
import { $actualSelectedModule, selectModule } from '../select'
import { $navbarStaticTitles } from '../translations'

NavBarModules.displayName = 'NavBarModules'

export function NavBarModules({
  onInteract,
}: {
  onInteract?: () => void
}): JSX.Element {
  const modules = useUnit($modules)
  const selectedModule = useUnit($actualSelectedModule)
  const navbarStaticTitles = useUnit($navbarStaticTitles)
  const navbarRedirectAnalytix = useUnit(navbarRedirect)

  return (
    <NavGroup titleMore={navbarStaticTitles.more}>
      {modules && modules.length > 0 ? (
        modules.map((module) => (
          <NavTab
            key={module.identifier}
            title={module.title}
            selected={selectedModule === module.identifier}
            onClick={() => {
              onInteract?.()
              selectModule(module.identifier)
              navbarRedirectAnalytix()
              navigate(module.link)
            }}
          />
        ))
      ) : (
        <></>
      )}
    </NavGroup>
  )
}
